import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::index
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:19
* @route '/admin-panel/message-templates'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/message-templates',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::index
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:19
* @route '/admin-panel/message-templates'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::index
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:19
* @route '/admin-panel/message-templates'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::index
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:19
* @route '/admin-panel/message-templates'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::index
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:19
* @route '/admin-panel/message-templates'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::index
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:19
* @route '/admin-panel/message-templates'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::index
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:19
* @route '/admin-panel/message-templates'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::destroy
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:43
* @route '/admin-panel/message-templates/{template}'
*/
export const destroy = (args: { template: string | { id: string } } | [template: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin-panel/message-templates/{template}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::destroy
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:43
* @route '/admin-panel/message-templates/{template}'
*/
destroy.url = (args: { template: string | { id: string } } | [template: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { template: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            template: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template: typeof args.template === 'object'
        ? args.template.id
        : args.template,
    }

    return destroy.definition.url
            .replace('{template}', parsedArgs.template.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::destroy
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:43
* @route '/admin-panel/message-templates/{template}'
*/
destroy.delete = (args: { template: string | { id: string } } | [template: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::destroy
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:43
* @route '/admin-panel/message-templates/{template}'
*/
const destroyForm = (args: { template: string | { id: string } } | [template: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageTemplatesController::destroy
* @see app/Http/Controllers/AdminPanel/MessageTemplatesController.php:43
* @route '/admin-panel/message-templates/{template}'
*/
destroyForm.delete = (args: { template: string | { id: string } } | [template: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const messageTemplates = {
    index: Object.assign(index, index),
    destroy: Object.assign(destroy, destroy),
}

export default messageTemplates